import Modal from '@paycor/modal';
import { useTranslation } from 'react-i18next';
import style from './style.module.scss';
import Button from '@paycor/picl/button';
import { Warning } from '@paycor/picl/icon';
import { Colors } from '@paycor/core';

export const ChangeTypeNotificationModal = ({ showModal, handleShowModal }) => {
	const { t } = useTranslation();
	const modalTitle = `${t('Workflow_not_turned_on', 'Workflow Not Turned On')}`;

	const ModalBody = () => {
		return (
			<>
				<div className={style.modal_body}>
					<Warning color={Colors.YELLOW1} height="2em" width="5em" />
					<div className={style.changtype_description}>
						<div>
							{t('The_associated_workflow_for_this_change_type_is_not_turned_on', 'The associated workflow for this change type is not turned on')}.{' '}
							{t(
								'If_a_change_type_is_selected_for_the_employee_without_the_associated_workflow_being_turned_on',
								'If a change type is selected for the employee without the associated workflow being turned on'
							)}
							,{' '}
							{t(
								'the_employee_will_be_able_to_change_their_data_without_going_through_approval_and/or_notification_steps',
								'the employee will be able to change their data without going through approval and/or notification steps'
							)}
							.
						</div>
						<div>
							{t('If_this_is_not_the_experience_you_intend', 'If this is not the experience you intend')},{' '}
							{t(
								'please_turn_on_the_associated_workflow_before_selecting_this_employee_change_type',
								'please turn on the associated workflow before selecting this employee change type'
							)}
							.
						</div>
					</div>
				</div>
			</>
		);
	};

	const BasicFooter = () => (
		<div className={style.basic_footer}>
			<Button type={Button.Types.PRIMARY} onClick={() => handleShowModal(false)}>
				{t('Close', 'Close')}
			</Button>
		</div>
	);

	return (
		<Modal
			show={showModal}
			body={<ModalBody />}
			size={Modal.Sizes.DEFAULT}
			title={modalTitle}
			footer={<BasicFooter />}
			onClose={() => handleShowModal(false)}
			footerStyle={Modal.Footer.DARK}
			backdrop
		/>
	);
};
